import React from 'react';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useReportExport } from 'utils/hooks/useReportExport';

const ExportReportButton: React.FC = () => {
  const { t } = useTranslation();
  const { exportReport, hasData } = useReportExport();

  return (
    <Button
      type='default'
      icon={<DownloadOutlined />}
      onClick={exportReport}
      disabled={!hasData}
    >
      {t('EXPORT_EXCEL', 'Export Excel')}
    </Button>
  );
};

export default ExportReportButton;
